import React from 'react'
import {
  Collection,
  ExecuteOperationForModelOnPipe,
  ExecuteOperationOnPipe,
  ForEachModel, useValue, WhenModel
} from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import { SquareButton } from 'ui/buttons'
import ScheduleSmartViewTabs from 'widgets/smartviews/shifts/ScheduleSmartViewTabs'
import Smartview from 'widgets/smartviews/Smartview'
import SmartviewHeader from 'widgets/smartviews/partials/SmartviewHeader'
import { VacationRequest } from 'ui/smartview'
import * as Filters from 'support/filters'
import { VerticalList } from 'ui/layouts'

function ScheduleVacationRequestsSmartview (props) {
  return (
    <WhenModel>
      <Smartview>
        <ScheduleSmartViewTabs active='vacation_requests' />

        <Collection resourceName='vacation.vacation_requests' operationName='index'>
          <Filters.ModelValueFilter name='schedule' modelKey='id' />

          <SmartviewHeader>
            Ferieanmodninger
          </SmartviewHeader>
          <Filters.SwitchFilter name='status' enum='request_status' defaultValue='pending' className={['mb-6']} size='small' fullWidth />

          <VerticalList className='vacation-requests'>
            <ForEachModel>
              <VacationRequest />
            </ForEachModel>
          </VerticalList>

        </Collection>
      </Smartview>
    </WhenModel>
  )
}

export default ScheduleVacationRequestsSmartview
